import { render } from "./link-whatsapp.vue?vue&type=template&id=4375cfc8"
import script from "./link-whatsapp.vue?vue&type=script&setup=true&lang=js"
export * from "./link-whatsapp.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/whatsapp/link-whatsapp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4375cfc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4375cfc8', __exports__)) {
    console.log('reload')
    api.reload('4375cfc8', __exports__)
  }
  
  module.hot.accept("./link-whatsapp.vue?vue&type=template&id=4375cfc8", () => {
    console.log('re-render')
    api.rerender('4375cfc8', render)
  })

}


export default __exports__